var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSetNoti(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 14.75V15.75C5.75 16.5456 6.06607 17.3087 6.62868 17.8713C7.19129 18.4339 7.95435 18.75 8.75 18.75C9.54565 18.75 10.3087 18.4339 10.8713 17.8713C11.4339 17.3087 11.75 16.5456 11.75 15.75V14.75M6.75 2.75C6.75 2.21957 6.96071 1.71086 7.33579 1.33579C7.71086 0.960714 8.21957 0.75 8.75 0.75C9.28043 0.75 9.78914 0.960714 10.1642 1.33579C10.5393 1.71086 10.75 2.21957 10.75 2.75C11.8984 3.29303 12.8774 4.13833 13.5821 5.1953C14.2867 6.25227 14.6904 7.48107 14.75 8.75V11.75C14.8253 12.3717 15.0454 12.9671 15.3928 13.4881C15.7402 14.0092 16.2051 14.4414 16.75 14.75H0.75C1.29494 14.4414 1.75981 14.0092 2.10719 13.4881C2.45457 12.9671 2.67474 12.3717 2.75 11.75V8.75C2.80956 7.48107 3.2133 6.25227 3.91795 5.1953C4.6226 4.13833 5.60159 3.29303 6.75 2.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetNoti);
export default __webpack_public_path__ + "static/media/icon_set_noti.f643d8274369afea986c5b4daab219eb.svg";
export { ForwardRef as ReactComponent };